import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, IconButton, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { http } from '../../clients/http/http.client';
import { Tooltip } from '@mui/material';
import Loader from "../Inputs/Loader/Loader";

function Widget({
                  endpoint,
                  queryString,
                  getValue,
                  getSubtitle,
                  title,
                  infoIcon = false,
                  infoTooltip = '',
                }) {
  const [data, setData] = useState({}); // Initialize as empty object for safety
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      console.log('queryString',queryString);
      try {
        const response = await http.client.get(`${endpoint}?${queryString}`);

          // Use response directly, as data is not nested under response.data
          const responseData = response || {};
          setData(responseData);
          setLoading(false);

      } catch (err) {
        console.error(`Error fetching data for ${title}:`, err, { endpoint, queryString });

          setData({}); // Set to empty object on error
          setLoading(false);

      }
    };
    fetchData();
  }, [endpoint, queryString, title]);

  if (loading) {
    return (
      <Box sx={{ width: '100%', height: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader />
      </Box>
    );
  }

  // Use try-catch to handle potential errors in getValue/getSubtitle
  let displayValue = 'N/A';
  let displaySubtitle = null;
  try {
    displayValue = Object.keys(data).length > 0 ? getValue(data) : 'N/A';
    if (getSubtitle) {
      displaySubtitle = Object.keys(data).length > 0 ? getSubtitle(data) : 'N/A';
    }
  } catch (err) {
    console.error(`Error computing display values for ${title}:`, err, { data });
  }

  return (
    <Card sx={{ backgroundColor: '#2C8EF8', color: '#fff', borderRadius: 4, boxShadow: 3, height: 140, position: 'relative' }}>
      <CardContent>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h4" fontWeight="bold" fontSize={24}>
            {displayValue}
          </Typography>
          {infoIcon && (
            <Tooltip
              title={infoTooltip}
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: 'white',
                    color: 'black',
                    fontSize: '16px',
                    borderRadius: 2,
                    boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
                    p: 1.5,
                  }
                },
                arrow: {
                  sx: { color: 'white' }
                }
              }}
            >
              <IconButton sx={{ position: 'absolute', top: 10, right: 10, padding: 0 }}>
                <InfoIcon sx={{ color: '#fff', width: 15, height: 15 }} />
              </IconButton>
            </Tooltip>
          )}
        </div>
        <Typography variant="body1" sx={{ mt: 1, fontSize: 12 }}>
          {title}
        </Typography>
        {displaySubtitle && (
          <Typography variant="caption" sx={{ opacity: 0.8, fontSize: 10, fontWeight: 500 }}>
            {displaySubtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}

export default Widget;